import { useRouter } from "next/router";
import Link from "next/link";

function BottomFooter({ data }) {
  const { locale } = useRouter();
  return (
    <div className="pt-4 text-white bg-black border border-black">
      <div className="w-11/12 max-[570px]:w-[98%] mx-auto max-[570px]:py-1">
        <ul className="flex max-[570px]:flex-col max-[991px]:flex-row items-center justify-center flex-wrap max-[570px]:py-4">
          {data?.["bottom-menu"]?.map((info) => (
            <li key={info?.url}>
              <Link href={`${info.url}`} className="pb-2 mx-4 hover:text-red">
                {info?.[`title-${locale}`]}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="bg-[#1C1B1B] mt-4">
        <div className="flex items-center gap-3 justify-center max-[850px]:block w-11/12 max-[570px]:w-[98%] mx-auto max-[570px]:py-1">
          <p className="flex items-center justify-center p-2 rounded-md">
            {data?.copyrights?.[locale]}
          </p>
          {/* <span className="max-[570px]:hidden">-</span>
          <p className="text-center">
            <span>{locale === 'ar' ? 'تم التطوير بواسطة: ' : 'Powered by: '}</span>
            <a href="https://v4tech.com/" target="_blank" className="font-bold">V4tech</a>
          </p> */}
        </div>
      </div>
    </div>
  );
}

export default BottomFooter;
